import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from '../containers/ErrorPage';

const Custom404 = ({ t }) => <ErrorPage t={t} statusCode={404} />;

Custom404.propTypes = {
  t: PropTypes.func,
};

export default Custom404;
